// 예약 불가 사유 코드 상수 (백엔드 응답값과 일치)
export const RV_INCOMPLETE_REASON = {
  ALREADY_RESERVED: "ALREADY_RESERVED", // 이미 예약 선점
  DAILY_QUOTA_EXCEED: "DAILY_QUOTA_EXCEED", // 일일 예약 시간 초과
  MONTHLY_QUOTA_EXCEED: "MONTHLY_QUOTA_EXCEED", // 월 예약 시간 초과
  CALENDAR_RESOURCE_DECLINED: "CALENDAR_RESOURCE_DECLINED", // 캘린더 리소스 거부
  CALENDAR_EMPTY_RESOURCE: "CALENDAR_EMPTY_RESOURCE", // 캘린더 리소스 할당자 없음
  CALENDAR_MULTIPLE_RESOURCES: "CALENDAR_MULTIPLE_RESOURCES", // 캘린더 리소스가 중복 지정
  OUT_OF_BOUNDS: "OUT_OF_BOUNDS", // 예약 가능 구간을 벗어남
  OUT_OF_TIME: "OUT_OF_TIME", // 예약 가능 시간 단위를 벗어남
  BUSINESS_CLOSED: "BUSINESS_CLOSED", // 휴무 시간에 예약
  UNKNOWN: "UNKNOWN", // 알 수 없음
  INVALID_START_TIME: "INVALID_START_TIME", // 	유효하지 않은 예약 시작 시간
} as const;

// Union 타입 정의
export type RvIncompleteReason = typeof RV_INCOMPLETE_REASON[keyof typeof RV_INCOMPLETE_REASON];

// 예약 불가 사유 메시지
export const RV_INCOMPLETE_REASON_MESSAGE: Record<RvIncompleteReason, string> = {
  [RV_INCOMPLETE_REASON.ALREADY_RESERVED]: "이미 예약 선점",
  [RV_INCOMPLETE_REASON.DAILY_QUOTA_EXCEED]: "일일 예약 시간 초과",
  [RV_INCOMPLETE_REASON.MONTHLY_QUOTA_EXCEED]: "월 예약 시간 초과",
  [RV_INCOMPLETE_REASON.CALENDAR_RESOURCE_DECLINED]: "캘린더 리소스 거부",
  [RV_INCOMPLETE_REASON.CALENDAR_EMPTY_RESOURCE]: "캘린더 리소스 할당자 없음",
  [RV_INCOMPLETE_REASON.CALENDAR_MULTIPLE_RESOURCES]: "캘린더 리소스가 중복 지정",
  [RV_INCOMPLETE_REASON.OUT_OF_BOUNDS]: "예약 가능 구간을 벗어남",
  [RV_INCOMPLETE_REASON.OUT_OF_TIME]: "예약 가능 시간 단위를 벗어남",
  [RV_INCOMPLETE_REASON.BUSINESS_CLOSED]: "휴무 시간에 예약",
  [RV_INCOMPLETE_REASON.UNKNOWN]: "알 수 없음",
  [RV_INCOMPLETE_REASON.INVALID_START_TIME]: "유효하지 않은 예약 시작 시간",
};

export const RV_CANCELLED_REASON = {
  DELETED: "DELETED", //삭제(탭, 캘린더에서 취소)
  FORCED_BY_OPERATOR: "FORCED_BY_OPERATOR", //관리자 강제 취소
  IN_USE: "IN_USE", //사용 중에 취소(legacy)
} as const;

export type RvCancelledReason = typeof RV_CANCELLED_REASON[keyof typeof RV_CANCELLED_REASON];

//  사용자 타입
export const RV_USER_TYPE = {
  SYSTEM: "SYSTEM", // 시스템
  TAAP: "TAAP", // 탭 사용자
  CENTRAL: "CENTRAL", // 센트럴 사용자
  CTRL_ROOM: "CTRL_ROOM", // 컨트롤 룸 사용자
  CALENDAR: "CALENDAR", // 캘린더 사용자
  TAAP_SPACE: "TAAP_SPACE", // 탭 스페이스 사용자
} as const;

export type RvUserType = typeof RV_USER_TYPE[keyof typeof RV_USER_TYPE];

export const RV_PROTECTION_STRATEGY = {
  NONE: "NONE", // 전체 공개
  PARTIAL_MASKING: "PARTIAL_MASKING", // 일부 공개(마스킹)
  PRIVATE: "PRIVATE", // 비공개
} as const;

export type RvProtectionStrategy = typeof RV_PROTECTION_STRATEGY[keyof typeof RV_PROTECTION_STRATEGY];
